/* KALII premium layer for Umino, v8.3.1 (ARGUS, 2026-10-10). The layer's only script: eight small, independent parts
   (3b added in v8.3.1).
   No network calls, no storage, nothing about prices, stock or the timer. Parts 1-6 are presentation; part 7 asks
   for a size before anything goes into the cart (the owner's decision). */

/* 1. The cart is KALII's AOV app drawer, exactly as on the live store. The app writes its own font (Poppins) into
   inline style attributes, two of them with !important, and no stylesheet can outrank those. In this theme the drawer
   speaks the site's one family (Jost): this swaps the font-family of elements inside #aov-cart-drawer, nothing else. */
(function () {
  var FONT = "Jost, sans-serif";
  function fix(root) {
    var els = root.querySelectorAll('[style*="font-family"]');
    for (var i = 0; i < els.length; i++) {
      var s = els[i].style;
      if (s.getPropertyValue("font-family") !== FONT || s.getPropertyPriority("font-family") !== "important") {
        s.setProperty("font-family", FONT, "important");
      }
    }
  }
  function attach(drawer) {
    fix(drawer);
    // the app re-renders the drawer (timer ticks, quantity changes): keep it in the site's font; fix() only writes when a
    // value differs, so its own style changes settle after one pass
    new MutationObserver(function () { fix(drawer); })
      .observe(drawer, { subtree: true, childList: true, attributes: true, attributeFilter: ["style"] });
  }
  var found = document.getElementById("aov-cart-drawer");
  if (found) { attach(found); return; }
  var watch = new MutationObserver(function () {
    var d = document.getElementById("aov-cart-drawer");
    if (d) { watch.disconnect(); attach(d); }
  });
  watch.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* 2. Size guide without leaving the product page (Thomas: "it should open a tab instead of opening a new page and
   having the customer leave the product page"). A size-guide link anywhere on a product page opens Umino's own
   size-guide pop-up; on pages without that pop-up the link opens the size-guide page as before. */
(function () {
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/pages/size-guide"]') : null;
    if (!a || a.classList.contains("open-popup-size-guide")) return;
    var trigger = document.querySelector(".open-popup-size-guide");
    if (!trigger) return;
    e.preventDefault();
    trigger.click();
  }, true);
})();

/* 3. Phone gallery (v8.7: the photos swipe sideways; v5-v8.6 scrolled them downwards): a line under the photo with a
   dark stretch that moves along as you swipe, one stretch per photo, no numbers (Thomas: "i actually preffer the
   scrolling line underneath from babyboo or wander"); it hides when a dress has a single photo. */
(function () {
  var galleries = document.querySelectorAll("[data-kalii-vgallery]");
  for (var i = 0; i < galleries.length; i++) {
    (function (g) {
      var wrap = g.parentNode, bar = wrap.querySelector(".kalii-vgallery__bar"), n = g.children.length, frame = 0;
      if (n < 2) { wrap.classList.add("is-single"); return; }
      if (bar) bar.style.setProperty("--kalii-vg-n", n);
      var set = function () {
        frame = 0;
        var at = Math.max(0, Math.min(n - 1, g.scrollLeft / Math.max(g.clientWidth, 1)));
        if (bar) bar.style.setProperty("--kalii-vg-i", at.toFixed(3));
      };
      g.addEventListener("scroll", function () { if (!frame) frame = requestAnimationFrame(set); }, { passive: true });
      window.addEventListener("resize", set);
      set();
    })(galleries[i]);
  }
})();

/* 3b. (v8.3.1-v8.6: the swipe hand-off after the LAST downward photo.) Removed in v8.7: sideways photos never hold the
   page, and its touch listener would have taken over sideways swipes. */

/* 4. Phones: while the page's own ADD TO CART is on screen, the sticky bar steps aside (CSS §29), so the buyer never
   sees two ADD TO CART buttons at once. The sticky bar itself stays (Thomas's tactic). */
(function () {
  var main = document.querySelector(".bls__product-details-infor .product-form__submit");
  if (!main || !("IntersectionObserver" in window)) return;
  new IntersectionObserver(function (entries) {
    document.body.classList.toggle("kalii-atc-inview", entries[0].isIntersecting);
  }, { threshold: 0.1 }).observe(main);
})();

/* v8.6 (2026-10-13, Thomas: "italian and spanish these 2 for sure"): Italian and Spanish next to French and German in
   §5 (size-chart columns BUSTO / VITA / FIANCHI and PECHO / CINTURA / CADERA, inches as pollici / pulg.), §6 (the size
   label Taglia: / Talla:) and §7 (the size prompt). Nothing else changes; English, French and German are untouched. */
/* 5. Size guide pop-up (v7, Thomas: "can you make the pop up look a bit more premium and not like a bunch of text ? like
   the one pop up natalie rolt looks"; "the numbers have to match their own attached size guides"). The chart stays
   plain rows in the theme editor (product template > size guide block): the first row names the columns, then one row
   per size, then free lines (model, notes). Before Umino copies the chart into its pop-up, this rebuilds it in Natalie
   Rolt's layout: CM / INCH, one tab per size, that size's body measurements and its AU / UK and EU sizes in two
   hairline tables, then the free lines. No figure is typed here: every number comes from the template's own chart;
   inches = cm / 2.54, one decimal. Opening the guide shows the size already chosen on the page. Styles: CSS §34.
   v7.1: the French / German charts (stored translations) name their body columns POITRINE / TAILLE / HANCHES and
   BRUST / TAILLE / HÜFTE; the first free line is the model line in every language. */
(function () {
  var BODY = /bust|waist|hip|chest|length|inseam|thigh|poitrine|taille|hanche|brust|hüfte|huefte|busto|vita|fianchi|pecho|cintura|cadera/i;
  var DASH = String.fromCharCode(8211);
  var lang = (document.documentElement.getAttribute("lang") || "en").slice(0, 2).toLowerCase();
  var UNIT = { fr: ["POUCES", "po", ","], de: ["ZOLL", "Zoll", ","], it: ["POLLICI", "pollici", ","], es: ["PULGADAS", "pulg.", ","] }[lang] || ["INCH", "in", "."];
  var el = function (tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  };
  var button = function (cls, attr, value, label, on) {
    var b = el("button", cls + (on ? " is-active" : ""), label);
    b.type = "button";
    b.setAttribute(attr, value);
    b.setAttribute("aria-pressed", on ? "true" : "false");
    return b;
  };
  var inches = function (v) {
    var parts = String(v).split(/[^0-9.,]+/), out = [];
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      var n = parseFloat(parts[i].replace(",", "."));
      if (isNaN(n)) return "";
      out.push((n / 2.54).toFixed(1).replace(".", UNIT[2]));
    }
    return out.length ? out.join(DASH) + " " + UNIT[1] : "";
  };
  var table = function (head, row, cols, body) {
    var t = el("table", "kalii-sg__table"), hr = t.createTHead().insertRow(), dr = t.createTBody().insertRow();
    for (var i = 0; i < cols.length; i++) {
      var v = row[cols[i]] || "", td = dr.insertCell();
      hr.appendChild(el("th", "", head[cols[i]]));
      if (body) {
        td.appendChild(el("span", "kalii-sg__cm", v + " cm"));
        td.appendChild(el("span", "kalii-sg__in", inches(v) || v + " cm"));
      } else {
        td.textContent = v;
      }
    }
    return t;
  };
  var build = function (src) {
    var ps = src.querySelectorAll("p"), rows = [], notes = [];
    for (var i = 0; i < ps.length; i++) {
      var t = (ps[i].textContent || "").trim();
      if (!t) continue;
      if (t.indexOf("|") > -1) {
        var cells = t.split("|");
        for (var c = 0; c < cells.length; c++) cells[c] = cells[c].trim();
        rows.push(cells);
      } else {
        notes.push(ps[i]);
      }
    }
    if (rows.length < 2) return;  // not a rows chart (a picture, a product's own chart): as it is
    var head = rows[0], body = [], conv = [];
    for (var h = 1; h < head.length; h++) (BODY.test(head[h]) ? body : conv).push(h);
    var root = el("div", "kalii-sg"), sizes = el("div", "kalii-sg__sizes");
    root.setAttribute("data-unit", "cm");
    if (body.length) {
      var units = el("div", "kalii-sg__units");
      units.appendChild(button("kalii-sg__unit", "data-kalii-unit", "cm", "CM", true));
      units.appendChild(button("kalii-sg__unit", "data-kalii-unit", "in", UNIT[0], false));
      root.appendChild(units);
    }
    root.appendChild(sizes);
    for (var r = 1; r < rows.length; r++) {
      var panel = el("div", "kalii-sg__panel" + (r === 1 ? " is-active" : ""));
      panel.setAttribute("data-kalii-panel", String(r));
      if (body.length) panel.appendChild(table(head, rows[r], body, true));
      if (conv.length) panel.appendChild(table(head, rows[r], conv, false));
      sizes.appendChild(button("kalii-sg__size", "data-kalii-size", String(r), rows[r][0], r === 1));
      root.appendChild(panel);
    }
    if (notes.length) {  // the owner's own lines move in as they are
      var box = el("div", "kalii-sg__notes");
      for (var n = 0; n < notes.length; n++) {
        if (n === 0) notes[n].classList.add("kalii-sg__model");
        box.appendChild(notes[n]);
      }
      root.appendChild(box);
    }
    while (src.firstChild) src.removeChild(src.firstChild);
    src.appendChild(root);
    src.classList.add("kalii-sg-built");
  };
  var buildAll = function () {
    var srcs = document.querySelectorAll("#popup-size-guide .product-sizechart-content:not(.kalii-sg-built)");
    for (var i = 0; i < srcs.length; i++) build(srcs[i]);
  };
  var show = function (root, key) {
    var tabs = root.querySelectorAll("[data-kalii-size]"), panels = root.querySelectorAll("[data-kalii-panel]");
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i].getAttribute("data-kalii-size") === key;
      tabs[i].classList.toggle("is-active", on);
      tabs[i].setAttribute("aria-pressed", on ? "true" : "false");
    }
    for (var j = 0; j < panels.length; j++) panels[j].classList.toggle("is-active", panels[j].getAttribute("data-kalii-panel") === key);
  };
  // the size the buyer has chosen: the product form's variant id, looked up in the product's own JSON
  var chosen = function () {
    if (document.documentElement.classList.contains("kalii-nosize")) return [];  // v8.3: no size chosen yet (part 7)
    var form = document.querySelector('.bls__product-details-infor form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    var id = form && form.querySelector('[name="id"]'), pj = document.querySelector("[data-product-json]");
    if (!id || !pj) return [];
    try {
      var vs = JSON.parse(pj.textContent).variants || [];
      for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(id.value)) return vs[i].options || [];
    } catch (x) { /* no product JSON: the first size stays shown */ }
    return [];
  };
  buildAll();
  document.addEventListener("shopify:section:load", buildAll);  // theme editor: a re-rendered product section
  // the switches inside the pop-up (Umino builds the pop-up from a copy of the chart, so the clicks are delegated)
  document.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-kalii-unit], [data-kalii-size]") : null;
    var root = b && b.closest(".kalii-sg");
    if (!root) return;
    e.preventDefault();
    if (b.hasAttribute("data-kalii-size")) { show(root, b.getAttribute("data-kalii-size")); return; }
    root.setAttribute("data-unit", b.getAttribute("data-kalii-unit"));
    var us = root.querySelectorAll("[data-kalii-unit]");
    for (var i = 0; i < us.length; i++) {
      us[i].classList.toggle("is-active", us[i] === b);
      us[i].setAttribute("aria-pressed", us[i] === b ? "true" : "false");
    }
  });
  // on opening (Umino's own click handler has just built the pop-up): show the chosen size's tab
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest || !e.target.closest(".open-popup-size-guide")) return;
    var root = document.querySelector("[id^='popup-size-guide_'] .kalii-sg");
    if (!root) return;
    var opts = chosen(), tabs = root.querySelectorAll("[data-kalii-size]");
    for (var t = 0; t < tabs.length; t++) {
      var names = (tabs[t].textContent || "").trim().toUpperCase().split("/");
      for (var o = 0; o < opts.length; o++) {
        if (names.indexOf(String(opts[o]).trim().toUpperCase()) > -1) { show(root, tabs[t].getAttribute("data-kalii-size")); return; }
      }
    }
  });
})();

/* 6. The size picker's label is the product's own option name ("Size"), which has no French / German version in the
   product data, so French and German pages read "Size:" in English (the cold judge's one instant-fail, 2026-10-09). On
   those pages the label becomes the language's word; English is untouched, and nothing else is renamed. */
(function () {
  var lang = (document.documentElement.getAttribute("lang") || "en").slice(0, 2).toLowerCase();
  var word = { fr: "Taille" + String.fromCharCode(160) + ":", de: "Gr" + String.fromCharCode(246, 223) + "e:", it: "Taglia:", es: "Talla:" }[lang];
  if (!word) return;
  var fix = function () {
    var labels = document.querySelectorAll(".swatch-attribute-label");
    for (var i = 0; i < labels.length; i++) {
      if ((labels[i].textContent || "").trim() === "Size:") labels[i].textContent = word;
    }
  };
  fix();
  // Umino redraws the size picker when a size is chosen: put the word back each time
  var picker = document.getElementById("variant-radios");
  if (picker && "MutationObserver" in window) new MutationObserver(fix).observe(picker, { childList: true, subtree: true });
})();

/* 7. No size chosen in advance (v8.3, Thomas 2026-10-09: "No pre-selected size: the shopper taps a size first, so
   nobody gets an XS by accident"). When a dress has two or more sizes in stock, its page opens with no size marked:
   the label reads "Size:" alone and the sticky bar's list reads "Size". Until a size is tapped, ADD TO CART (page and
   sticky bar) and the express buttons (Shop Pay, More payment options) add nothing: one small line under the sizes
   asks for a size and the page scrolls to them. The first size tapped, on the page or in the sticky list, is the
   buyer's choice; from there Umino works exactly as before and redraws the picker with that size marked. A page that
   is reloaded or reached with the back button keeps the size the buyer chose. Prices, the stock line and the layout
   are unchanged. A dress with one size in stock, or a product with two options, works as before. Styles: CSS §40. */
(function () {
  var info = document.querySelector(".bls__product-details-infor");
  var picker = info && info.querySelector("variant-selects");
  var pj = document.querySelector("[data-product-json]");
  if (!picker || !pj) return;
  var product;
  try { product = JSON.parse(pj.textContent); } catch (x) { return; }
  var variants = product.variants || [], open = 0;
  for (var i = 0; i < variants.length; i++) if (variants[i].available) open++;
  if ((product.options || []).length !== 1 || open < 2) return;
  var nav = (window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0]) || {};
  if (/[?&]variant=[0-9]+/.test(location.search) && (nav.type === "reload" || nav.type === "back_forward")) return;
  var lang = (document.documentElement.getAttribute("lang") || "en").slice(0, 2).toLowerCase();
  var size = "Gr" + String.fromCharCode(246, 223) + "e";
  var T = {
    fr: ["Veuillez s" + String.fromCharCode(233) + "lectionner une taille", "Taille"],
    de: ["Bitte w" + String.fromCharCode(228) + "hle eine " + size, size],
    it: ["Seleziona una taglia", "Taglia"],
    es: ["Selecciona una talla", "Talla"]
  }[lang] || ["Please select a size", "Size"];
  var root = document.documentElement, chosen = false;
  var clear = function () {
    var marked = picker.querySelectorAll(".bls__option-swatch.active");
    for (var m = 0; m < marked.length; m++) marked[m].classList.remove("active");
    var v = picker.querySelector(".swatch-selected-value");
    if (v && v.textContent.trim()) v.textContent = "";
  };
  root.classList.add("kalii-nosize");
  clear();
  // the sticky bar's list starts on "Size", a line nobody can send
  var sticky = document.querySelector("#bls__sticky-addcart select[name='id']"), placeholder = null;
  if (sticky) {
    placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = T[1];
    placeholder.disabled = true;
    sticky.insertBefore(placeholder, sticky.firstChild);
    placeholder.selected = true;
  }
  // the line that asks for a size, right under the sizes
  var prompt = document.createElement("p");
  prompt.className = "kalii-size-prompt";
  prompt.setAttribute("role", "alert");
  prompt.hidden = true;
  prompt.textContent = T[0];
  picker.parentNode.insertBefore(prompt, picker.nextSibling);
  // an invisible layer over the express buttons (some of them draw inside frames that no click handler reaches)
  var pay = info.querySelector(".shopify-payment-button"), guard = null;
  if (pay) {
    guard = document.createElement("span");
    guard.className = "kalii-pay-guard";
    guard.setAttribute("aria-hidden", "true");
    pay.classList.add("kalii-needs-size");
    pay.appendChild(guard);
  }
  var ask = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    prompt.hidden = false;
    (picker.querySelector("fieldset") || picker).scrollIntoView({ behavior: "smooth", block: "center" });
  };
  var done = function () {
    root.classList.remove("kalii-nosize");
    prompt.hidden = true;
    if (guard && guard.parentNode) guard.parentNode.removeChild(guard);
    if (pay) pay.classList.remove("kalii-needs-size");
    if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
  };
  document.addEventListener("click", function (e) {
    if (chosen || !e.target || !e.target.closest) return;
    if (e.target.closest(".kalii-pay-guard, #bls__sticky-addcart .product-form__submit, .bls__product-details-infor .product-form__submit")) ask(e);
  }, true);
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (chosen || !f || !f.closest || (f.getAttribute("action") || "").indexOf("/cart/add") < 0) return;
    if (f.closest(".bls__product-details-infor, #bls__sticky-addcart")) ask(e);
  }, true);
  // the buyer's first size: a tap on the page (marked as chosen before Umino's own handler runs)...
  picker.addEventListener("click", function (e) {
    var sw = !chosen && e.target && e.target.closest ? e.target.closest(".bls__option-swatch") : null;
    if (!sw) return;
    chosen = true;
    var picked = sw.getAttribute("data-value") || "";
    setTimeout(function () {
      var v = picker.querySelector(".swatch-selected-value");  // Umino may have redrawn the picker meanwhile
      if (v && !v.textContent.trim()) v.textContent = " " + picked + " ";
      if (!picker.querySelector(".bls__option-swatch.active")) sw.classList.add("active");
      done();
    }, 0);
  }, true);
  // ...or in the sticky bar's list: the page's sizes follow it, so both forms carry the same size
  if (sticky) sticky.addEventListener("change", function () {
    if (chosen || !sticky.value) return;
    var opt = null;
    for (var k = 0; k < variants.length; k++) if (String(variants[k].id) === sticky.value) opt = variants[k].option1;
    var sws = picker.querySelectorAll(".bls__option-swatch");
    for (var s = 0; s < sws.length; s++) {
      if (sws[s].getAttribute("data-value") === opt) { sws[s].click(); return; }
    }
    chosen = true;
    done();
  });
  // before that first tap, nothing marks a size behind the buyer's back
  if ("MutationObserver" in window) new MutationObserver(function () { if (!chosen) clear(); })
    .observe(picker, { subtree: true, childList: true, attributes: true, attributeFilter: ["class"] });
})();
/* 8. Italian sticky bar (v8.6; Thomas 10-13 chose "A: AGGIUNGI, one line"). On phones the sticky bar's button says "AGGIUNGI": the
   full "Aggiungi al carrello" took two lines on every phone (bar 73 -> 94px) and covered the stars line under the price.
   The page's own button keeps the full words; "Esaurito" and every other state are untouched. The theme rewrites the
   label whenever a size is chosen, so a watcher puts the short word back each time the full one appears. */
(function () {
  var lang = (document.documentElement.getAttribute("lang") || "en").slice(0, 2).toLowerCase();
  var SHORT = { it: "Aggiungi" }[lang];
  var span = document.querySelector("#bls__sticky-addcart .product-form__submit > span:not(.loader-icon)");
  if (!SHORT || !span) return;
  var full = ((window.variantStrings && window.variantStrings.addToCart) || "").trim();
  var fix = function () { if (full && span.textContent.trim() === full) span.textContent = SHORT; };
  fix();
  if ("MutationObserver" in window) new MutationObserver(fix).observe(span, { childList: true, characterData: true, subtree: true });
})();
